import React, { useState, useEffect } from 'react';

import { ShoppingOutlined } from '@ant-design/icons';
import { Card, Statistic, Spin, Alert } from 'antd';
import { useTranslation } from 'react-i18next';

import operatorApiFetch from '@services/operator/apiService';

const PendingOrdersWidget = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState({
    count: 0,
    date_range: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await operatorApiFetch('dashboard/pending_orders');
        const result = await response.json();

        if (result.success) {
          setData(result.data);
        } else {
          setError(result.message || t('common.error.fetch_failed'));
        }
      } catch (err) {
        console.error('[PendingOrdersWidget] Error:', err);
        setError(t('common.error.fetch_failed'));
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [t]);

  if (loading) {
    return (
      <Card className="dashboard-widget">
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <Spin />
        </div>
      </Card>
    );
  }

  if (error) {
    return (
      <Card className="dashboard-widget">
        <Alert message={error} type="error" showIcon />
      </Card>
    );
  }

  return (
    <Card className="dashboard-widget dashboard-widget--pending-orders">
      <Statistic
        title={t('operator.dashboard.widgets.pending_orders.title')}
        value={data.count}
        prefix={<ShoppingOutlined />}
        valueStyle={{ color: '#faad14' }}
      />
    </Card>
  );
};

export default PendingOrdersWidget;
